// components/ComplianceCircle.js
import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import './styles/ComplianceCircle.css';

function ComplianceCircle({ passed, total, size = 180 }) {
  const percentage = total > 0 ? ((passed / total) * 100).toFixed(0) : 0;

  const data = [
    { name: 'Passed', value: passed },
    { name: 'Remaining', value: total - passed },
  ];

  const COLORS = ['#4caf50', '#e0e0e0'];

  return (
    <div className="compliance-circle-wrapper">
      <div style={{ position: 'relative', width: size, height: size }}>
        <PieChart width={size} height={size}>
          <Pie
            data={data}
            cx={size / 2}
            cy={size / 2}
            innerRadius={size * 0.38} // 70/180 ≈ 0.38
            outerRadius={size * 0.47} // 85/180 ≈ 0.47
            startAngle={90}
            endAngle={-270}
            dataKey="value"
            animationDuration={800}
            animationBegin={0}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index]} stroke="none" />
            ))}
          </Pie>
        </PieChart>

        {/* 中間的數字 */}
        <div className="circle-label">
          <div className="circle-number">
            <span style={{ fontSize: '1.4rem' }} className="passed">{passed}</span>
            <span style={{ fontSize: '1.4rem' }} className="separator">/</span>
            <span style={{ fontSize: '1.4rem' }} className="total">{total}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ComplianceCircle;
